import { useMemo } from "react";
import { Skeleton } from "@heroui/react";
import useFieldDashboard from "@/lib/fieldDashboard/useFieldDashboard";
import IrrigationSystemForm from "./IrrigationSystemForm";

function IrrigationSystems() {
    const { fieldId, fieldQuery, geometryQuery } = useFieldDashboard() ?? {};
    const irrigationSystems = useMemo(() => {
        return fieldQuery?.data?.irrigation_systems ?? [];
    }, [fieldQuery?.data]);
    const fieldBoundary = useMemo(() => {
        return geometryQuery?.data?.field;
    }, [geometryQuery?.data?.field]);

    return (
        <div className="flex flex-col gap-2 w-full">
            {!fieldId ? (
                <Skeleton className="h-4 w-1/2" />
            ) : irrigationSystems?.length === 0 ? (
                <IrrigationSystemForm
                    fieldId={fieldId}
                    growerId={fieldQuery?.data?.grower}
                    fieldBoundary={fieldBoundary}
                    irrigationSystemId={undefined}
                />
            ) : (
                <IrrigationSystemForm
                    fieldId={fieldId}
                    growerId={fieldQuery?.data?.grower}
                    fieldBoundary={fieldBoundary}
                    irrigationSystemId={irrigationSystems[0].id}
                />
            )}
        </div>
    );
}

export default IrrigationSystems;